import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService';
import * as validationService from "../add-device-modal/validationService";

function EnablePasswordTextField({ enablePassword, error, disabled }) {

    useEffect(() => {
        /*  if (anotherSectionActive) {
             validationService.cleanValidation('enablePassword');
             onChange('');
         } else { */
        validationService.validateNotEmpty(enablePassword, 'enablePassword')
        // }
        return () => validationService.cleanValidation('enablePassword');
    }, [enablePassword])

    const onChange = (value) => modalDataService.changeEnablePasswordText(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="enablePasswordText">Enable Password <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="enablePasswordText"
                    type="password"
                    value={enablePassword}
                    disabled={disabled}
                    placeholder="••••••••"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("EnablePasswordTextField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    //const anotherSectionActive = !!addDeviceModal.enablePassword;

    return {
        enablePassword: addDeviceModal.enablePassword || '',
        error: validation.enablePassword,
        //anotherSectionActive
    }
}

export default connect(mapStateToProps)(EnablePasswordTextField);
